import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface LogoutConfirmDialogProps {
  open: boolean;
  onClose: (confirmed: boolean) => void;
}

const LogoutConfirmDialog: React.FC<LogoutConfirmDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      fullWidth
      maxWidth="xs"
      sx={{
        "& .MuiDialog-paper": {
          top: "5%",
          margin: "0 auto",
          position: "absolute",
        },
      }}
    >
      <DialogTitle
        style={{
          backgroundColor: "var(--primary-color)",
          color: "var(--aggrid-text-color)",
          fontSize: "36px",
          fontWeight: "bolder",
          padding: "12px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Logout
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => onClose(false)}
          style={{ color: "var(--aggrid-text-color)" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        style={{ fontSize: "12px", marginTop: "20px", padding: "1px 24px" }}
      >
        Are you sure you want to logout?
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(true)}
          style={{
            fontSize: "14px",
            height: "2.1em",
            padding: "4px 6px",
            border: "1px solid #144979",
          }}
        >
          Yes
        </Button>
        <Button
          onClick={() => onClose(false)}
          style={{
            fontSize: "14px",
            height: "2.1em",
            padding: "4px 6px",
            border: "1px solid #144979",
          }}
          autoFocus
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmDialog;
